<!--
 * @Author: tiandi
 * @Date: 2021-05-20 10:15:19
 * @LastEditTime: 2022-09-15 19:26:28
 * @LastEditors: Smart Chow
 * @Description: 上级检查整改弹框页面
   
 * @FilePath: /nqc-pc-ui/src/apps/modules/qc-plan/plan/_components/dialog/PlanEditDialog.vue
-->
<template>
  <div class="modal-window" style="padding-bottom: 40px">
    <section class="form">
      <span class="reason-title">原因分析列表：</span>
      <div class="select-table-btn">
        <more-cols
          ref="moreCols"
          class="mr-10 wn-fr"
          :show-table-col-list="tableAllColumns"
          :show-table-check-list.sync="showDefaultTable"
          @getLastCheckList="getLastCheckList"
        ></more-cols>
      </div>
      <w-table ref="selectTable" :data="wtData" border>
        <w-table-column type="expand">
          <template slot-scope="scope">
            <template
              v-if="
                ZGHistory_1 && ZGHistory_1.some((m) => m.WTXH == scope.row.WTXH)
              "
            >
              <w-row
                style="text-align: center; font-weight: bold; font-size: 20px"
              >
                <span>历史整改评价记录</span>
              </w-row>
              <w-form
                v-for="(wtItem, wtIndex) in ZGHistory_1.filter(
                  (m) => m.WTXH == scope.row.WTXH
                )"
                ref="history"
                :key="wtIndex"
                label-width="120px"
                label-align="right"
                class="mb-10"
              >
                <w-row v-if="ZGHistory_1 && ZGHistory_1.length > 1">
                  <span style="font-weight: bold; font-size: 16px">
                    第{{ wtIndex + 1 }}次整改评价记录
                  </span>
                </w-row>
                <w-row class="mt-10">
                  <w-col :span="8">
                    <w-form-item label="整改时间：">
                      <span>
                        {{ moment(wtItem.ZGSJ).format('YYYY-MM-DD') }}
                      </span>
                    </w-form-item>
                  </w-col>
                  <w-col :span="8">
                    <w-form-item label="整改人：">
                      <span
                        >{{
                          wtItem.ZGR_MC ? `${wtItem.ZGR_MC}(${wtItem.ZGR})` : ''
                        }}
                      </span>
                    </w-form-item>
                  </w-col>
                  <w-col :span="8">
                    <w-form-item label="整改执行人：">
                      <span
                        >{{
                          wtItem.ZXR_MC ? `${wtItem.ZXR_MC}(${wtItem.ZXR})` : ''
                        }}
                      </span>
                    </w-form-item>
                  </w-col>
                </w-row>
                <w-form-item label="原因分析：" class="mt-10">
                  <w-input
                    :value="wtItem.YYFX"
                    type="textarea"
                    disabled
                    :rows="3"
                    :maxlength="1000"
                    show-counter
                  ></w-input>
                </w-form-item>
                <w-form-item label="整改措施：">
                  <w-input
                    :value="wtItem.ZGCS"
                    type="textarea"
                    disabled
                    :maxlength="1000"
                    :rows="3"
                    show-counter
                  ></w-input>
                </w-form-item>
                <!-- 备用字段，根据后台新增 -->
                <template v-for="(item, index) in BYList">
                  <w-form-item
                    v-if="item.need"
                    :key="index"
                    :label="`${item.label}：`"
                    class="mt-20"
                  >
                    <w-input
                      :value="wtItem[item.name]"
                      type="textarea"
                      disabled
                      :maxlength="1000"
                      :rows="3"
                      show-counter
                    ></w-input>
                  </w-form-item>
                </template>
                <w-form-item
                  v-if="
                    PJHistory_1 &&
                    PJHistory_1.filter((m) => m.WTXH == scope.row.WTXH)
                  "
                  label="评价记录："
                >
                  <w-table
                    :ref="`pjTable${scope.$index}`"
                    :data="
                      PJHistory_1.filter(
                        (m) =>
                          m.WTXH == scope.row.WTXH && m.PLFXDM == wtItem.PLFXDM
                      )
                    "
                    width="80%"
                    border
                  >
                    <w-table-column label="评价结果" width="100" prop="GJXGMC">
                    </w-table-column>
                    <w-table-column
                      label="评价内容"
                      prop="GZPJ"
                      min-width="180"
                    ></w-table-column>
                    <w-table-column label="评价时间" width="120" prop="PJSJ">
                      <template slot-scope="scope1">
                        {{ moment(scope1.row.PJSJ).format('YYYY-MM-DD') }}
                      </template>
                    </w-table-column>
                    <w-table-column label="评价人" prop="PJRMC" width="150">
                      <template slot-scope="scope1">
                        {{
                          scope1.row.PJRMC
                            ? `${scope1.row.PJRMC}(${scope1.row.PJRDM})`
                            : ''
                        }}
                      </template>
                    </w-table-column>
                    <w-table-column label="审核人" width="150" prop="SHRMC">
                      <template slot-scope="scope1">
                        {{
                          scope1.row.SHRMC
                            ? `${scope1.row.SHRMC}(${scope1.row.SHRDM})`
                            : ''
                        }}
                      </template>
                    </w-table-column>
                  </w-table>
                </w-form-item>
              </w-form>
            </template>
            <span v-else>无历史整改评价记录</span>
          </template>
        </w-table-column>
        <w-table-column
          v-for="item in showDefaultTable"
          :key="item.key"
          :prop="item.key"
          :label="item.name"
          :align="item.align"
          :min-width="item.minWidth"
          :width="item.width"
        >
        </w-table-column>
      </w-table>

      <w-form
        ref="planForm"
        label-width="120px"
        label-align="right"
        class="mt-10"
        :model="zgObj"
        :rules="rules"
      >
        <w-form-item
          label="整改时间："
          :prop="zgStatus || type == 1 ? '' : 'ZGSJ'"
        >
          <w-date-picker
            v-model="zgObj.ZGSJ"
            width="200"
            :disabled="zgStatus || type == 1"
            :clearable="false"
            size="small"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择日期"
          ></w-date-picker>
        </w-form-item>
        <w-row class="mt-10">
          <w-col :span="12">
            <w-form-item label="整改人：">
              <w-select
                ref="selectZGR"
                v-model="zgObj.ZGRObj"
                width="200"
                :disabled="zgStatus || type == 1"
                placeholder="请选择"
                value-key="id"
              >
                <w-option
                  v-for="item in cyList"
                  :key="item.id"
                  :label="item.name + '(' + item.id + ')'"
                  :value="item"
                ></w-option>
              </w-select>
            </w-form-item>
          </w-col>
          <w-col :span="12">
            <w-form-item label="整改执行人：">
              <w-select
                ref="selectZGR"
                v-model="zgObj.ZXRObj"
                width="200"
                :disabled="zgStatus || type == 1"
                placeholder="请选择"
                value-key="id"
              >
                <w-option
                  v-for="item in cyList"
                  :key="item.id"
                  :label="item.name + '(' + item.id + ')'"
                  :value="item"
                ></w-option>
              </w-select>
            </w-form-item>
          </w-col>
        </w-row>
        <w-form-item
          label="原因分析："
          class="mt-10"
          :prop="zgStatus || type == 1 ? '' : 'YYFX'"
        >
          <w-row>
            <w-input
              v-model="zgObj.YYFX"
              type="textarea"
              :disabled="zgStatus || type == 1"
              :rows="3"
              :maxlength="1000"
              show-counter
            ></w-input>
            <w-button
              :disabled="zgStatus || type == 1"
              type="text"
              @click="popZsk(zgObj, '1083', 'YYFX', '原因分析')"
            >
              引用原因分析模板
            </w-button>
          </w-row>
        </w-form-item>
        <w-form-item
          label="整改措施："
          :prop="zgStatus || type == 1 ? '' : 'ZGCS'"
        >
          <w-row>
            <w-input
              v-model="zgObj.ZGCS"
              type="textarea"
              :disabled="zgStatus || type == 1"
              :rows="3"
              :maxlength="1000"
              show-counter
            ></w-input>
            <w-button
              :disabled="zgStatus || type == 1"
              type="text"
              @click="popZsk(zgObj, '1084', 'ZGCS', '整改措施')"
              >引用整改措施模板
            </w-button>
          </w-row>
        </w-form-item>
        <!-- 备用字段，根据后台新增 -->
        <template v-for="(item, index) in BYList">
          <w-form-item
            v-if="item.need"
            :key="index"
            :label="`${item.label}：`"
            :prop="zgStatus || type == 1 ? '' : item.name"
            class="mt-20"
          >
            <w-row>
              <w-input
                v-model="zgObj[item.name]"
                type="textarea"
                :disabled="zgStatus || type == 1"
                :rows="4"
                :maxlength="1000"
                show-counter
              ></w-input>
              <w-button
                :disabled="zgStatus || type == 1"
                type="text"
                @click="popZsk(zgObj, item.code, item.name, item.label)"
                >引用{{ item.label }}模板
              </w-button>
            </w-row>
          </w-form-item>
        </template>
        <w-form-item label="附件" label-width="120px">
          <w-upload
            class="upload-demo"
            action=""
            accept=".jpg,.jpeg,.png,.bmp,.gif"
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            :http-request="uploadFile"
            :show-file-list="false"
            :limit="5"
            :disabled="uploadedFile.length >= 5"
            :file-list="fileList"
          >
            <w-button size="small" icon="w-icon-upload" type="primary">
              点击上传
            </w-button>
            <div slot="tip" class="w-upload__tip" style="color: ">
              <div>文件类型支持：jpg、jpeg、png、bmp、gif</div>
              <w-link
                v-show="uploadedFile.length >= 5"
                :underline="false"
                type="warning"
              >
                最多只能上传5个文件
              </w-link>
            </div>
          </w-upload>

          <div v-if="uploadedFile.length > 0" class="file">
            <div style="color: rgb(181 181 181)">
              下方为已上传附件,共{{
                uploadedFile.length
              }}个(点击文件右侧按钮进行删除)
            </div>
            <div
              v-for="(item, index) in uploadedFile"
              :key="item.id"
              class="file-item"
            >
              <w-image
                v-if="item.type == 'image'"
                class="file-item-icon"
                style="width: 80px; height: 80px"
                :src="item.url"
                :preview-src-list="[item.url]"
              >
              </w-image>
              <div v-else class="w-icon-file file-item-icon"></div>
              <w-link type="primary" :href="item.url" target="_blank">
                {{ item.name }}
              </w-link>
              <i
                v-if="!readonly"
                class="w-icon-delete remove"
                @click.stop="remove(item)"
              ></i>
              <i class="number">{{ index + 1 }}</i>
            </div>
          </div>
        </w-form-item>
      </w-form>
      <div v-if="needZP" class="mt-20">
        <div>跟踪评价：</div>
        <w-table :data="pjData" class="mt-10">
          <w-table-column v-if="showZPColumn" width="100" label="评价结果">
            <template>
              {{ showZPText }}
            </template>
          </w-table-column>
          <w-table-column label="评价内容">
            <template slot-scope="scope">
              <span v-if="!scope.row.canEdit">
                {{ scope.row.GZPJ }}
              </span>
              <div v-else style="position: relative">
                <w-input
                  v-model="scope.row.GZPJ"
                  :maxlength="1000"
                  type="textarea"
                  :autosize="{
                    minRows: 3,
                    maxRows: 6
                  }"
                >
                </w-input>
                <w-button
                  style="position: absolute; bottom: 5px; right: 5px"
                  type="text"
                  @click="popZsk(scope.row, '1116', 'GZPJ', '评价内容')"
                >
                  引用
                </w-button>
              </div>
            </template>
          </w-table-column>
          <w-table-column label="评价时间" width="180">
            <template slot-scope="scope">
              <w-date-picker
                v-if="scope.row.canEdit"
                v-model="scope.row.PJSJ"
                type="date"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                style="width: 80%"
              ></w-date-picker>
              <span v-else>{{
                moment(scope.row.PJSJ).format('YYYY-MM-DD')
              }}</span>
            </template>
          </w-table-column>
          <w-table-column label="评价人" prop="PJR" width="180">
            <template slot-scope="scope">
              <span v-if="!scope.row.canEdit">
                {{ scope.row.PJRMC + '(' + scope.row.PJR + ')' }}
              </span>
              <span v-else>
                <w-select
                  ref="select"
                  v-model="scope.row.PJR"
                  placeholder="请选择"
                  value-key="id"
                >
                  <w-option
                    v-for="item in cyList"
                    :key="item.id"
                    :label="item.name + '(' + item.id + ')'"
                    :value="item"
                  ></w-option>
                </w-select>
              </span>
            </template>
          </w-table-column>
          <w-table-column label="审核人" width="180">
            <template slot-scope="scope">
              <span v-if="!scope.row.canEdit">
                {{ scope.row.SHRMC + '(' + scope.row.SHR + ')' }}
              </span>
              <span v-else>
                <w-select
                  ref="select"
                  v-model="scope.row.SHR"
                  placeholder="请选择"
                  value-key="id"
                >
                  <w-option
                    v-for="item in cyList"
                    :key="item.id"
                    :label="item.name + '(' + item.id + ')'"
                    :value="item"
                  ></w-option>
                </w-select>
              </span>
            </template>
          </w-table-column>
          <w-table-column width="70" align="left">
            <template slot-scope="scope">
              <w-button
                type="error"
                size="small"
                icon="w-icon-close"
                circle
                @click="delZP(scope.$index)"
              ></w-button>
            </template>
          </w-table-column>
        </w-table>
        <w-button class="mt-10" size="mini" type="primary" @click="addZP">
          新增评价
        </w-button>
      </div>
    </section>

    <div class="modal-window-footer">
      <div class="window-footer-btns">
        <w-button @click="exit()"> 取消 </w-button>
        <w-button
          v-if="!isOver && type != 1"
          type="primary"
          @click="saveSubmit(0)"
        >
          保存
        </w-button>
        <w-button v-if="!isOver" type="primary" @click="saveSubmit(1)">
          提交
        </w-button>
      </div>
    </div>
  </div>
</template>

<script>
import zskSelect from '@/apps/modules/qc-rectification/qualityImprovementEvaluation/_components/dialog/zskSelect.vue'
import moment from 'moment'
import MoreCols from '@/common/components/MoreCols'
import { getTableCheckColumns } from '@/common/utils'
import axios from 'axios'

export default {
  name: 'QcRectificationDetail',
  components: { MoreCols },
  props: {
    selectedArr: {
      type: Array,
      default: () => {
        return []
      }
    },
    wtxhs: {
      type: String,
      default: () => ''
    },
    plfxdm: {
      type: String,
      default: () => ''
    },
    fxxh: {
      type: String,
      default: () => ''
    },
    type: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      UserInfo: {},
      wtData: [],
      ZGHistory: [], //整改记录（存在重新重改的需要给展示出来）

      ZGHistory_1: [], //整改记录（持续整改的整改记录）
      PJHistory_1: [], // 评价记录 （持续整改的历史记录）
      pjData: [],
      pjObj: {
        canEdit: true,
        JGDM: -1,
        PJJG: {},
        GJXGDM: '1099',
        GJXGMC: '自评',
        GZPJ: '',
        PJSJ: '',
        PJR: {},
        PJRDM: '',
        PJRMC: '',
        SHR: {},
        SHRDM: '',
        SHRMC: ''
      },
      pjResult: [],
      cyList: [],
      refresh: false,
      BYList: [
        { name: 'BY1', code: '1080', need: false, label: '原因分析' },
        { name: 'BY2', code: '1081', need: false, label: '备用1' },
        { name: 'BY3', code: '1082', need: false, label: '备用1' }
      ],
      zgStatus: false, // 是否已完成整改
      isOver: false, //用于判断是否完成所有，不让操作
      needZP: false, //是否需要自评
      zgObj: {
        // 整改数据
        ZGSJ: '',
        ZGCS: '',
        ZGRObj: {},
        ZGR: '',
        ZGR_MC: '',
        ZXRObj: {},
        ZXR: '',
        ZXR_MC: '',
        YYFX: '',
        BY1: '',
        BY2: '',
        BY3: '',
        TJZT: 0 // 0保存 1提交
      },
      rules: {
        ZGSJ: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ],
        ZGR: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ],
        ZGZXR: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ],
        YYFX: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ],
        ZGCS: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ],
        BY1: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ],
        BY2: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ],
        BY3: [
          {
            required: true,
            message: '',
            trigger: 'change'
          }
        ]
      },
      showZPColumn: true,
      showZPText: '',
      autoCanle: false, //校验后自动退出,
      xtmj1098: false, //是否需要自评
      xtmj1194: false, //是否强制自评
      tableAllColumns: [
        //整改详情页面，表格全部字段
        {
          name: '序号',
          key: 'INDEX',
          align: 'center',
          width: '62',
          keepChoosing: false,
          checked: true
        },
        {
          name: '受检科室',
          key: 'ZZJGMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: false
        },
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'center',
          width: '220',
          keepChoosing: false,
          checked: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分标准',
          key: 'KFMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: true
        },
        {
          name: '存在问题',
          key: 'CZWTMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'JCKFYY',
          align: 'center',
          minWidth: '300px',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分',
          key: 'JGZ',
          align: 'center',
          minWidth: '92px',
          keepChoosing: false,
          checked: true
        },
        {
          name: '问题来源',
          key: 'ZKJBMC',
          align: 'center',
          width: '280',
          keepChoosing: false,
          checked: false
        },
        {
          name: '督查时间',
          key: 'WCSJ',
          align: 'center',
          width: '240',
          keepChoosing: false,
          checked: false
        },
        {
          name: '被查人',
          key: 'BCRMC',
          align: 'center',
          width: '100',
          keepChoosing: false,
          checked: false
        },
        {
          name: '责任人',
          key: 'ZRRMC',
          align: 'center',
          width: '120',
          keepChoosing: false,
          checked: false
        },
        {
          name: '备注',
          key: 'MEMO',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: false
        },
        {
          name: '整改要点',
          key: 'ZGYD',
          align: 'center',
          width: '160',
          minWidth: '200px',
          keepChoosing: false,
          checked: true
        }
      ],
      showDefaultTable: [
        {
          name: '序号',
          key: 'INDEX',
          align: 'center',
          width: '62',
          keepChoosing: false,
          checked: true
        },
        {
          name: '受检科室',
          key: 'ZZJGMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: true
        },
        {
          name: '检查表单',
          key: 'BDMC',
          align: 'center',
          width: '160',
          keepChoosing: false,
          checked: false
        },
        {
          name: '检查项目',
          key: 'XMMC',
          align: 'center',
          width: '220',
          keepChoosing: false,
          checked: true
        },
        {
          name: '质量标准',
          key: 'BZMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: true
        },
        {
          name: '存在问题',
          key: 'CZWTMC',
          align: 'center',
          width: '200',
          keepChoosing: false,
          checked: true
        },
        {
          name: '扣分原因',
          key: 'JCKFYY',
          align: 'center',
          minWidth: '300px',
          keepChoosing: true,
          checked: true
        },
        {
          name: '扣分',
          key: 'JGZ',
          minWidth: '92px',
          align: 'center',
          keepChoosing: false,
          checked: true
        },
        {
          name: '整改要点',
          key: 'ZGYD',
          align: 'center',
          minWidth: '200px',
          keepChoosing: false,
          checked: true
        }
      ],
      fileList: [],
      uploadedFile: []
    }
  },
  computed: {},
  created() {
    this.showDefaultTable = getTableCheckColumns(
      'zg_detailDialog',
      this.tableAllColumns
    )
    this.UserInfo = this.$store.state.user.loginUserInfo
    this.pjObj.PJSJ = moment().format('YYYY-MM-DD')
    this.zgObj.ZGSJ = moment().format('YYYY-MM-DD')
    this.zgObj.ZGR = this.UserInfo.UserId
    this.zgObj.ZGR_MC = this.UserInfo.UserName
    this.zgObj.ZGRObj = { id: this.zgObj.ZGR, name: this.zgObj.ZGR_MC }
    this.zgObj.ZXR = this.UserInfo.UserId
    this.zgObj.ZXR_MC = this.UserInfo.UserName
    this.zgObj.ZXRObj = { id: this.zgObj.ZXR, name: this.zgObj.ZXR_MC }
    this.getBY()
    this.getNeedZP()
    this.getuserList()
    this.GetZPList()
    this.getSysTemSetting()
  },
  mounted() {
    let modal = document.getElementsByClassName('modal-window')[0]
    modal.addEventListener('scroll', this.handleSrcoll)
    this.GetWTInfo()
    this.getZGInfo()
    this.GetZGHistory()
  },
  watch: {
    showTableCheckList(val) {
      if (this.$refs.selectTable) {
        this.$refs.selectTable.doLayout()
      }
    }
  },
  methods: {
    handleSrcoll() {
      for (
        let i = 0;
        i < document.getElementsByClassName('w-select').length;
        i++
      ) {
        document.getElementsByClassName('w-select')[i].blur()
      }
    },
    // 查询是否需要自评
    getNeedZP() {
      let that = this
      this.$requestApi('GetXTMJList', { Mjdm: '1098,1099' }).then((res) => {
        if (res.data) {
          if (res.data && res.data.length > 0) {
            this.needZP = res.data.find((m) => m.MJDM == 1098).JLZT == '1'
            this.showZPColumn = res.data.find((m) => m.MJDM == 1099).JLZT == '1'
            this.showZPText =
              res.data.find((m) => m.MJDM == 1099).MJMC || '自评'
          }
        }
      })
    },
    // 获取问题展示
    GetWTInfo() {
      this.$requestApi('GetWTInfo', {
        wtxhs: this.wtxhs
      }).then((res) => {
        if (res.success) {
          this.wtData = res.data.map((item, index) => ({
            ...item,
            ...{ INDEX: index + 1 }
          }))
          this.wtData.forEach((item) => {
            item.WCSJ = item.WCSJ.slice(0, 10)
            item.CZWTMC = item.KFMC
          })
        }
      })
    },
    // 整改信息
    getZGInfo() {
      let that = this
      this.$requestApi('GetZGInfo', {
        wtxhs: this.wtxhs
      }).then((res) => {
        if (res.success) {
          if (res.data && res.data.length > 0) {
            // 增加校验，如果所有问题的整改信息相同或者都为空时才让一起批量整改
            if (res.data.length > 1) {
              for (let index = 1; index < res.data.length; index++) {
                const nowItem = res.data[index]
                const lastItem = res.data[index - 1]
                if (
                  nowItem.ZGSJ != lastItem.ZGSJ ||
                  nowItem.YYFX != lastItem.YYFX ||
                  nowItem.ZGCS != lastItem.ZGCS ||
                  nowItem.BY1 != lastItem.BY1 ||
                  nowItem.BY2 != lastItem.BY2 ||
                  nowItem.BY3 != lastItem.BY3
                ) {
                  if (that.autoCanle) {
                    // 另外一个判断已经弹出返回，不重复
                    return
                  }
                  this.$Confirm(
                    '部分数据已存在整改记录，不能进行批量整改操作',
                    '提示',
                    {
                      confirmButtonText: '确定',
                      showCancelButton: false,
                      showClose: false,
                      closeOnClickModal: false,
                      type: 'warning'
                    }
                  )
                    .then(() => {
                      that.$emit('close', { type: false })
                    })
                    .catch(() => {})
                  that.autoCanle = true
                  return
                }
              }
            }

            this.zgObj.ZGCS = res.data[0].ZGSJ
            this.zgObj.YYFX = res.data[0].YYFX || ''
            this.zgObj.ZGCS = res.data[0].ZGCS || ''
            this.zgObj.BY1 = res.data[0].BY1 || ''
            this.zgObj.BY2 = res.data[0].BY2 || ''
            this.zgObj.BY3 = res.data[0].BY3 || ''
            this.uploadedFile = res.data[0].ZgFileList.map((m) => {
              return {
                id: m.id,
                name: m.name,
                url: m.url,
                type: that.getfileType(m.name)
              }
            })

            if (res.data[0].ZGR && res.data[0].ZGR_MC) {
              this.zgObj.ZGR = res.data[0].ZGR
              this.zgObj.ZGR_MC = res.data[0].ZGR_MC
              this.zgObj.ZGRObj = {
                id: this.zgObj.ZGR,
                name: this.zgObj.ZGR_MC
              }
            }
            if (res.data[0].ZXR && res.data[0].ZXR_MC) {
              this.zgObj.ZXR = res.data[0].ZXR
              this.zgObj.ZXR_MC = res.data[0].ZXR_MC
              this.zgObj.ZXRObj = {
                id: this.zgObj.ZXR,
                name: this.zgObj.ZXR_MC
              }
            }

            // 只要存在已整改的数据，设置为已整改状态，防止错误
            if (res.data.some((m) => m.TJZT == 1)) {
              this.zgStatus = true
            }
          }
        }
      })
    },
    // 历史整改信息
    GetZGHistory() {
      this.$requestApi('GetZGHistory', {
        plfxdm: this.plfxdm,
        fxxh: this.fxxh
      }).then((res) => {
        this.ZGHistory = res.data
      })
      this.$requestApi('GetZGHistoryByWTXH', {
        wtxhs: this.wtxhs
      }).then((res) => {
        this.ZGHistory_1 = res.data
      })
      this.$requestApi('GetPJHistoryByWTXH', {
        wtxhs: this.wtxhs
      }).then((res) => {
        this.PJHistory_1 = res.data
      })
    },
    // 自评记录信息
    GetZPList() {
      let that = this
      this.$requestApi('GetZPList', {
        wtxhs: that.wtxhs
      }).then((res) => {
        that.pjData = []
        let zpGroup = []
        //处理数据
        res.data.forEach((m, index, arr) => {
          let currentObj = {
            ...m,
            canEdit: m.GJXGDM == 1099,
            PJR: { id: m.PJRDM, name: m.PJRMC },
            SHR: { id: m.SHRDM, name: m.SHRMC }
          }
          if (zpGroup.some((k) => k.WTXH == m.WTXH)) {
            var flag = zpGroup.find((k) => k.WTXH == m.WTXH)
            flag.zpList.push({ ...currentObj })
          } else {
            zpGroup.push({
              WTXH: m.WTXH,
              zpList: [{ ...currentObj }]
            })
          }
          //如果以前的历史数据中人员，已经不在部门人员内，需要添加进来，否则下拉会为空
          if (!that.cyList.some((x) => x.id == m.PJRDM)) {
            that.cyList.push({
              id: m.PJRDM,
              name: m.PJRMC
            })
          }
          if (!that.cyList.some((x) => x.id == m.SHRDM)) {
            that.cyList.push({
              id: m.SHRDM,
              name: m.SHRMC
            })
          }
        })

        // 循环判断是否存在自评不一致的，不一致弹出返回提示
        zpGroup.forEach((item) => {
          // 校验如果其他问题存在不同的自评记录，那么就退出
          let otherWT = zpGroup.filter((k) => k.WTXH != item.WTXH)
          let isSame = true
          item.zpList.forEach((m) => {
            otherWT.forEach((element) => {
              if (
                !element.zpList.some((k) => {
                  return (
                    m.GJXGDM == k.GJXGDM &&
                    m.PJRDM == k.PJRDM &&
                    m.SHRDM == k.SHRDM &&
                    m.PJSJ == k.PJSJ &&
                    m.GZPJ == k.GZPJ
                  )
                })
              ) {
                isSame = false && isSame
              }
            })
            if (!isSame) {
              if (that.autoCanle) {
                // 另外一个判断已经弹出返回，不重复
                return
              }
              that
                .$Confirm('部分自评数据不一致，不能进行批量整改操作', '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  showClose: false,
                  closeOnClickModal: false,
                  type: 'warning'
                })
                .then(() => {
                  that.$emit('close', { type: false })
                })
                .catch(() => {})
              that.autoCanle = true
              return
            }
          })
        })

        that.pjData = zpGroup && zpGroup.length > 0 ? zpGroup[0].zpList : []
      })
    },
    //获取备用字段信息
    getBY() {
      let that = this
      this.$requestApi('GetXTMJList', { Mjlx: '024' }).then((res) => {
        if (res.data) {
          res.data.forEach((item) => {
            let flag = that.BYList.find((m) => m.code == item.MJDM)
            if (flag) {
              flag.label = item.MJMC
              flag.need = item.JLZT == '1'
            }
          })
        }
      })
    },
    //获取评价人、审核人的人员列表
    getuserList() {
      this.$requestApi('GetUserForZG', { wtxhs: this.wtxhs }).then((res) => {
        this.cyList = res.data
      })
    },
    //弹出评价内容选择框
    popZsk(row, type, columnName, title) {
      let width = window.innerWidth * 0.5
      let height = window.innerHeight * 0.7
      let bddms = this.wtData.map((m) => m.BDDM).join(',')
      let zzjgdms = this.wtData.map((m) => m.ZZJGDM).join(',')
      var index = this.$dlg.modal(zskSelect, {
        title: '知识库' + `-${title}`,
        width: width,
        height: height,
        params: { zskLx: type, bddms: bddms, zzjgdms: zzjgdms },
        callback: (data) => {
          if (data && data.length > 0) {
            var str = data.map((m) => m.MEMO).join(';')
            row[columnName] += str
          }
        },
        cancelCallback: () => {}
      })
    },
    addZP() {
      this.pjObj.PJRDM = this.UserInfo.UserId
      this.pjObj.PJRMC = this.UserInfo.UserName
      this.pjObj.PJR = { id: this.pjObj.PJRDM, name: this.pjObj.PJRMC }
      this.pjObj.SHRDM = this.UserInfo.UserId
      this.pjObj.SHRMC = this.UserInfo.UserName
      this.pjObj.SHR = { id: this.pjObj.SHRDM, name: this.pjObj.SHRMC }
      this.pjObj.PJSJ = moment().format('YYYY-MM-DD')

      this.pjData.push({ ...this.pjObj })
    },
    delZP(index) {
      this.$Confirm('是否删除该条数据', '提示', {
        type: 'warning'
      })
        .then((res) => {
          this.pjData.splice(index, 1)
        })
        .catch(() => {})
    },
    // 校验数据是否完整
    checkInfo() {
      this.zgObj.ZGR = this.zgObj.ZGRObj.id
      this.zgObj.ZGR_MC = this.zgObj.ZGRObj.name
      this.zgObj.ZXR = this.zgObj.ZXRObj.id
      this.zgObj.ZXR_MC = this.zgObj.ZXRObj.name

      // 自评的时候，不校验整改信息(后续自评可以在整改前填写)
      if (this.type != 1) {
        if (this.zgObj.YYFX.length == 0) {
          this.$msg('请填写原因分析！')
          return false
        }
        if (this.zgObj.ZGCS.length == 0) {
          this.$msg('请填写整改措施！')
          return false
        }
        if (this.zgObj.ZGR.length == 0) {
          this.$msg('请选择评价人！')
          return false
        }
        if (this.zgObj.ZXR.length == 0) {
          this.$msg('请选择整改执行人！')
          return false
        }

        for (let index = 0; index < this.BYList.length; index++) {
          const item = this.BYList[index]
          if (item.need && this.zgObj[item.name].length == 0) {
            this.$msg(`请填写${item.label}!`)
            return false
          }
        }
      }

      for (let index = 0; index < this.pjData.length; index++) {
        const item = this.pjData[index]
        if (item.GZPJ.length == 0) {
          this.$msg(`请填写评价内容!`)
          return false
        }

        if (!item.PJSJ) {
          this.$msg(`请填写评价时间!`)
          return false
        }
        item.PJRDM = item.PJR.id
        item.PJRMC = item.PJR.name
        item.SHRDM = item.SHR.id
        item.SHRMC = item.SHR.name
        if (item.PJRDM.length == 0) {
          this.$msg(`请选择评价人!`)
          return false
        }
        if (item.SHRDM.length == 0) {
          this.$msg(`请选择审核人!`)
          return false
        }
      }
      return true
    },
    // 保存或提交
    saveSubmit(type) {
      let that = this
      this.$refs.planForm.validateForm((valid) => {})
      if (!that.checkInfo()) {
        return
      }
      let data = {
        ...that.zgObj,
        ZGR: that.zgObj.ZGRObj.id,
        ZGR_MC: that.zgObj.ZGRObj.name,
        ZXR: that.zgObj.ZXRObj.id,
        ZXR_MC: that.zgObj.ZXRObj.name,
        PLFXDM: that.plfxdm,
        FXXH: that.fxxh,
        WTXH: that.wtxhs,
        TJZT: type,
        OperateUser: that.UserInfo.UserId,
        type: that.type
      }
      if (type == 1) {
        if (that.pjData.length <= 0 && this.xtmj1098 && this.xtmj1194) {
          this.$msg('请先进行自评')
          return false
        }
      }

      data.zpList = []
      if (that.pjData.length > 0) {
        that.pjData.forEach((item) => {
          let obj = {
            ...item,
            PLFXDM: that.plfxdm,
            FXXH: that.fxxh,
            WTXH: that.wtxhs,
            PJRDM: item.PJR.id,
            PJRMC: item.PJR.name,
            SHRDM: item.SHR.id,
            SHRMC: item.SHR.name
          }
          data.zpList.push(obj)
        })
      } else {
      }
      if (type == 1) {
        that
          .$Confirm('是否提交？', '提示', {
            type: 'warning'
          })
          .then((res1) => {
            that.refresh = true
            that.save(data, type)
          })
          .catch(() => {})
      } else {
        that.refresh = true
        that.save(data, type)
      }
    },
    save(data, type) {
      let that = this
      that.$requestApi('SaveZGInfo', data).then((res) => {
        if (res.success) {
          that.$msg('操作成功', 'success')
          if (type == 1) {
            that.$emit('close', { type: this.refresh })
          } else {
            that.plfxdm = res.data
          }
        }
      })
    },
    exit() {
      this.$emit('close', { type: this.refresh })
    },
    //获取自评参数设置
    getSysTemSetting() {
      let Mjdm = '1098,1194'
      let params = this.$requestApi('GetXTMJList', { Mjdm }).then((res) => {
        if (res.success) {
          let data = res.data
          this.xtmj1098 = data.find((item) => item.MJDM == 1098).JLZT == '1'
          this.xtmj1194 = data.find((item) => item.MJDM == 1194).JLZT == '1'
        }
      })
    },
    getLastCheckList(val) {
      if (val.length > 0) {
        localStorage.setItem(
          'zg_detailDialog',
          JSON.stringify({
            showTableCheckList: val
          })
        )
      } else {
        localStorage.removeItem('zg_detailDialog')
      }
    },
    // 上传
    uploadFile(file) {
      let that = this
      let fd = new FormData()
      let userInfo = this.$store.state.user.loginUserInfo
      fd.append('file', file.file)
      fd.append('REFNO', this.wtxhs)
      fd.append('ATTACHTYPE', 'WTRectification')
      fd.append('UserId', userInfo.UserId)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      axios
        .post(`${window.globalConfig.BaseUrl}NQCS/UploadFile`, fd, config)
        .then((res) => {
          if (!res.data.success) {
            this.$message({
              message: res.data.message,
              customClass: 'close-msg'
            })
            var el = document.querySelector('.close-msg')
            if (el) el.style.cssText = 'z-index: 9999'
          } else {
            let obj = {}
            obj.id = res.data.data.id
            obj.name = file.file.name
            obj.url = res.data.data.url
            obj.type = that.getfileType(obj.name)

            this.uploadedFile.push(obj)
          }
        })
        .catch((error) => {
          this.$message(error)
        })
    },
    beforeRemove(file, fileList) {},
    // 删除问题关联的上传文件
    handleRemove(file, fileList) {
      console.log(file, fileList)
    },
    view(file) {},
    remove(file) {
      let that = this
      this.$Confirm(`是否删除关联的文件【${file.name}】`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then((res) => {
          this.$requestApi('RemoveAttach', {
            id: file.id
          }).then((res) => {
            if (res.success) {
              that.$msg('删除成功！', 'success')

              let index = that.uploadedFile.findIndex((m) => m.id == file.id)
              if (index > -1) {
                that.uploadedFile.splice(index, 1)
              }
            }
          })
        })
        .catch(() => {})
    },
    getfileType(name) {
      if (name.indexOf('.txt') > -1) {
        return 'txt'
      }
      if (
        name.indexOf('.png') > -1 ||
        name.indexOf('.jpg') > -1 ||
        name.indexOf('.bmp') > -1
      ) {
        return 'image'
      }
      if (name.indexOf('.xls') > -1 || name.indexOf('.xlsx') > -1) {
        return 'excel'
      }
      if (name.indexOf('.pdf') > -1) {
        return 'pdf'
      }
      if (name.indexOf('.ppt') > -1 || name.indexOf('.pptx') > -1) {
        return 'ppt'
      }
      if (name.indexOf('.doc') > -1 || name.indexOf('.docx') > -1) {
        return 'word'
      }
    }
  },
  windowConfigs: {
    maxButton: false,
    width: document.body.clientWidth,
    height: document.body.clientHeight
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-bottom: 20px;
  position: relative;
  /deep/ .w-form-item__error {
    display: none;
  }
}
.table-title {
  font-size: 13px;
  color: #666;
  margin: 5px 0;
  font-weight: bold;
}
.table-inner-row-text {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.reason-title {
  display: inline-block;
  margin-bottom: 10px;
}
.select-table-btn {
  position: absolute;
  right: 10px;
  top: -4px;
}
</style>
